export default {
      id: "video-event_cargo-door-open-usage",
      viewBox: "0 0 45 39",
      url: __webpack_public_path__ + "img/icons.svg#video-event_cargo-door-open",
      toString: function () {
        return this.url;
      }
    }